import { render, staticRenderFns } from "./SupplierInvoice.vue?vue&type=template&id=68d2b336&"
import script from "./SupplierInvoice.vue?vue&type=script&lang=js&"
export * from "./SupplierInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports